import React from 'react';

import { IconButton } from '@/components/shared/components/IconButton';
import { useNotificationsContext } from '@/contexts/NotificationsContext/NotificationsContext';

const CopyToClipboardButton = ({
  value,
  buttonStyle,
  style,
}: {
  value: string;
  buttonStyle?: React.CSSProperties;
  style?: React.CSSProperties;
}) => {
  const {
    actions: { setSnackbarNotification },
  } = useNotificationsContext();

  const copySuccessfulMessage = () => {
    setSnackbarNotification({
      msg: 'COPY_SUCCESSFUL',
      level: 'success',
    });
  };

  // Make it work both in secure and insecure contexts (iPhone, iPad, etc.)
  const copyToClipboard = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        copySuccessfulMessage();
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = value;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (successful) {
          copySuccessfulMessage();
        }
      }
    } catch (error) {}
  };

  return (
    <IconButton
      icon="copy"
      iconProps={{ size: 14, style: { ...style } }}
      style={{ height: 16, width: 16, ...buttonStyle }}
      onClick={(e) => {
        e.stopPropagation();
        copyToClipboard();
      }}
    />
  );
};

export { CopyToClipboardButton };
